module.exports = __webpack_public_path__ + "static/media/Hosts@2x.3fefd4a2.png";